namespace $ {

	/** Event-driven process lifecycle. Unlike a decorator, it need not finish in one call. */
	export class $shm_hitalama_process_observation extends $mol_object {
		readonly process: $shm_hitalama_process< unknown >
		private children = new Map< string, $shm_hitalama_process_observation >()
		private settled = false
		private label: string
		private waiting_promise?: PromiseLike< unknown >
		private waiting_text = ''
		changed = ()=> {}

		constructor( readonly host: object, readonly key: string, label: string, private readonly parent?: $shm_hitalama_process_observation, args: readonly unknown[] = [] ) {
			super()
			this.label = label
			this.process = new $shm_hitalama_process< unknown >( async()=> undefined, host, key, args )
			this.process.parent = parent?.process
			this.process.data_update({ label, status: 'running', started_at: new $mol_time_moment, started_tick: performance.now() })
			$shm_hitalama_process.register( host, $shm_hitalama_process_wire_inline_method( key ), this.process )
		}

		pending() { return !this.settled }
		private notify() { this.changed(); this.parent?.notify() }

		rename( label: string ) {
			if( this.label === label ) return
			this.label = label
			this.process.data_update({ label })
		}

		step( key: string, label: string, args: readonly unknown[] = [] ) {
			let child = this.children.get( key )
			if( !child ) {
				child = new $shm_hitalama_process_observation( this.host, this.key + '/' + key, label, this, args )
				this.children.set( key, child )
				if( this.settled ) child.cancel()
			}
			return child
		}

		wait( promise?: PromiseLike< unknown >, waiting = '' ) {
			if( this.settled || this.waiting_promise === promise && this.waiting_text === waiting ) return
			this.waiting_promise = promise
			this.waiting_text = waiting
			const fiber = promise ? $mol_wire_auto() : undefined
			this.process.data_update({ promise, waiting, fiber: fiber instanceof $mol_wire_fiber ? fiber : undefined })
			this.notify()
		}

		/** Observe an existing read; do not resume it or subscribe to extra data. */
		read< Value >( task: ()=> Value ): Value {
			if( this.settled ) return task()
			return $mol_error_fence(
				()=> { const value = task(); this.done(); return value },
				error => { this.fail( error ); return $mol_fail_hidden( error ) },
				promise => { this.wait( promise ); return $mol_fail_hidden( promise ) },
			)
		}

		done( result?: unknown ) { this.finish( 'done', undefined, result ) }
		fail( error: unknown ) { this.finish( 'failed', error ) }
		cancel() { this.finish( 'superseded' ) }

		private finish( status: $shm_hitalama_process_status, error?: unknown, result?: unknown ) {
			if( this.settled ) return
			this.settled = true
			this.waiting_promise = undefined
			this.waiting_text = ''
			this.process.data_update({ status, error, result, finished_at: new $mol_time_moment, finished_tick: performance.now(), promise: undefined, fiber: undefined, waiting: undefined })
			if( status !== 'done' ) for( const child of this.children.values() ) child.cancel()
			this.notify()
		}

		destructor() {
			this.cancel()
			$shm_hitalama_process.forget( this.process )
			this.children.clear()
			super.destructor()
		}
	}
}
